'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCompact$002dFeature from "./presto.types$-Compact-Feature.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CompactFeature$() {
}
export { $c_Lpresto_types$CompactFeature$ as $c_Lpresto_types$CompactFeature$ };
$p = $c_Lpresto_types$CompactFeature$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CompactFeature$;
/** @constructor */
function $h_Lpresto_types$CompactFeature$() {
}
export { $h_Lpresto_types$CompactFeature$ as $h_Lpresto_types$CompactFeature$ };
$h_Lpresto_types$CompactFeature$.prototype = $p;
$p.l = (function() {
  return "CompactFeature";
});
$p.adE = (function(x$0) {
  return new $j_presto$002etypes$0024$002dCompact$002dFeature.$c_Lpresto_types$CompactFeature(x$0.j(0), x$0.j(1));
});
var $d_Lpresto_types$CompactFeature$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CompactFeature$, "presto.types$CompactFeature$", ({
  YR: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$CompactFeature$ as $d_Lpresto_types$CompactFeature$ };
var $n_Lpresto_types$CompactFeature$;
function $m_Lpresto_types$CompactFeature$() {
  if ((!$n_Lpresto_types$CompactFeature$)) {
    $n_Lpresto_types$CompactFeature$ = new $c_Lpresto_types$CompactFeature$();
  }
  return $n_Lpresto_types$CompactFeature$;
}
export { $m_Lpresto_types$CompactFeature$ as $m_Lpresto_types$CompactFeature$ };
//# sourceMappingURL=presto.types$-Compact-Feature$.js.map
